/*
 * <kremi-autoplay> — temanın <scroll-carousel>'ine otomatik geçiş ekler (09-17).
 * İlk kullanım: Birbirini Tamamlayan Ürünler (snippets/complementary-products.liquid).
 *
 * DİNAMİK (kullanıcı kararı 09-17):
 * - `interval` ms'de bir (varsayılan 4000) sonraki karta geçer; son karttan başa döner.
 * - Masaüstü: fare kartların ya da noktaların üzerindeyken DURUR, ayrılınca süre
 *   baştan (4 sn) başlar.
 * - Mobil: parmak değdiği an durur; kaydırma bitip carousel oturunca ("carousel:settle")
 *   süre baştan başlar. Noktaya dokunmak da aynı şekilde sayacı sıfırlar.
 * - Klavye odağı içerideyken durur (erişilebilirlik).
 * - Görünmüyorsa (ekran dışı, sekme arka planda) saymaz; görünür olunca baştan başlar.
 * - Kaydırılacak bir şey yoksa (tüm kartlar sığıyorsa) hiç çalışmaz.
 * - "Hareketi azalt" tercihi olan kullanıcıda çalışmaz.
 *
 * Neden ayrı bileşen: öneriler sayfaya AJAX ile sonradan gelir; özel eleman, içerik
 * DOM'a girdiği anda connectedCallback ile kendiliğinden kurulur. Dosya sayfa
 * yüklemesinde snippet'in DIŞ kısmından yüklenir (AJAX yanıtındaki <script> çalışmaz).
 */
(() => {
  if (customElements.get('kremi-autoplay')) return;

  class KremiAutoplay extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('scroll-carousel');
      if (!this.carousel) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.interval = parseInt(this.getAttribute('interval'), 10) || 4000;
      this.hovered = false;
      this.touching = false;
      this.focused = false;
      this.inView = false;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      const passive = { signal: this.abort.signal, passive: true };

      // Masaüstü hover — yalnız fare (dokunmatikte pointerenter da tetiklenir).
      this.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        this.hovered = true;
        this.stop();
      }, opts);
      this.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        this.hovered = false;
        this.schedule();
      }, opts);

      // Dokunma / sürükleme / tekerlek: kullanıcı kaydırıyor → dur.
      this.addEventListener('touchstart', () => { this.touching = true; this.stop(); }, passive);
      const release = () => { this.touching = false; this.schedule(); };
      this.addEventListener('touchend', release, passive);
      this.addEventListener('touchcancel', release, passive);
      this.carousel.addEventListener('pointerdown', (e) => { if (e.pointerType === 'mouse') this.stop(); }, opts);
      this.carousel.addEventListener('wheel', () => this.schedule(), passive);

      // Kaydırma (kullanıcı ya da otomatik) oturduğunda süre BAŞTAN başlar.
      this.carousel.addEventListener('carousel:settle', () => this.schedule(), opts);

      this.addEventListener('focusin', () => { this.focused = true; this.stop(); }, opts);
      this.addEventListener('focusout', (e) => {
        if (this.contains(e.relatedTarget)) return;
        this.focused = false;
        this.schedule();
      }, opts);

      document.addEventListener('visibilitychange', () => this.schedule(), opts);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries.some((entry) => entry.isIntersecting);
        this.schedule();
      }, { threshold: 0.5 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.observer?.disconnect();
    }

    get paused() {
      return this.hovered || this.touching || this.focused || !this.inView || document.hidden;
    }

    stop() {
      clearTimeout(this.timer);
      this.timer = null;
    }

    schedule() {
      this.stop();
      if (this.paused || !this.carousel.isScrollable) return;
      this.timer = setTimeout(() => this.advance(), this.interval);
    }

    advance() {
      if (this.paused) return;
      const c = this.carousel;
      const atEnd = Math.abs(c.scrollLeft) + c.clientWidth >= c.scrollWidth - 2;
      if (atEnd || c.selectedIndex >= c.cells.length - 1) {
        c.select(0);
      } else {
        c.next();
      }
      // Yedek: "settle" gelmezse (ör. hedef zaten görünürdeyse) döngü durmasın.
      this.schedule();
    }
  }

  customElements.define('kremi-autoplay', KremiAutoplay);
})();
